import { graphql } from "~/gql";

export const CREATE_RATE = graphql(/* GraphQL */ `
  mutation createRate($data: RateCreateInput!) {
    createRate(data: $data) {
      ...RateParts
    }
  }
`);
